import { observable, action, computed } from 'mobx';
import { sanitizeName } from 'filestack-js';
import FirebaseService from '../services/impl/firebase/FirebaseService';

class UserStore {
  @observable users = null;
  @observable todayMeetings = {};
  @observable upcomingMeetings = {};

  constructor(rootStore) {
    this.rootStore = rootStore;
  }

  @action setUsers = users => {
    this.users = users;
  };

  @action setUser = (user, uid) => {
    if (!this.users) {
      this.users = {};
    }
    this.users[uid] = user;
    debugger
  };

  // @action loadMeetings = (firebase, uid) => {
    // const midNightDate = new Date();
    // const nextMidNightDate = new Date();
    // midNightDate.setHours(0,0,0,0);
    // nextMidNightDate.setHours(24,0,0,0);
    
  //   firebase
  //     .meetings(uid)
  //     .orderByChild('startTime')
  //     .startAt(midNightDate.getTime())
  //     .limitToFirst(5)
  //     .on('value', snapshot => {
  //       snapshot.forEach(meeting => {
  //         let mkey = meeting.key
  //         let val = meeting.val() 
  //         if (meeting.val().startTime < nextMidNightDate.getTime()) {          
  //           this.todayMeetings[mkey] = val
  //         }
  //         else {
  //           this.upcomingMeetings[mkey] = val
  //         }
  //       });
  //     });
  // }

  @action fetchMeetings = ( uid, date) => {

    const midNightDate = date;
    const nextMidNightDate = new Date(date);
    midNightDate.setHours(0,0,0,0);
    nextMidNightDate.setHours(24,0,0,0);
    this.todayMeetings = {};
    FirebaseService.getInstance()
      .meetings(uid)
      .orderByChild('startTime')
      .startAt(midNightDate.getTime())
      .limitToFirst(5)
      .on('value', snapshot => {
        snapshot.forEach(meeting => {
          let mkey = meeting.key
          let val = meeting.val()
          if (midNightDate.getTime() < meeting.val().startTime && meeting.val().startTime < nextMidNightDate.getTime()) {
            this.todayMeetings[mkey] = val
          }
        });
      });
  }

  @computed get userList() {
    return Object.keys(this.users || {}).map(key => ({
      ...this.users[key],
      uid: key,
    }));
  }
}

export default UserStore;
 


    //----------------------------Code For 2 days before and after selected date
    // const selectedDate = date;  // Pass date here
    // const dayBeforePreviousDay = new Date(selectedDate);
    // const previousDay = new Date(selectedDate);
    // const nextDay = new Date(selectedDate);
    // const dayAfterNextDay = new Date(selectedDate);
    // dayBeforePreviousDay.setDate(dayBeforePreviousDay.getDate() + -2);
    // previousDay.setDate(previousDay.getDate() + -1);
    // nextDay.setDate(nextDay.getDate() + 1);
    // dayAfterNextDay.setDate(dayAfterNextDay.getDate() + 2);